/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum TranslationFilterType {
    All = 0,
    Translated = 1,
    NotTranslated = 2,
}
